import { render } from "./CLOListPage.vue?vue&type=template&id=05d36332&scoped=true"
import script from "./CLOListPage.vue?vue&type=script&lang=js"
export * from "./CLOListPage.vue?vue&type=script&lang=js"

import "./CLOListPage.vue?vue&type=style&index=0&id=05d36332&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d36332"]])

export default __exports__